import React, { useState } from 'react';

import lobbyBannerContext from './lobbyBannerContext';
import { EMPTY_STRING } from 'commons/constants/immutable';

interface LobbyBannerProviderProps {
	children: React.ReactNode;
}

const lobbyBannerProvider: React.FC<LobbyBannerProviderProps> = ({ children }) => {
	const [lobbyBannerData, setLobbyBannerData] = useState({
		rowCount: 0,
		data: [],
		gameName: EMPTY_STRING
	});
	return <lobbyBannerContext.Provider value={{ lobbyBannerData, setLobbyBannerData }}>{children}</lobbyBannerContext.Provider>;
};

export default lobbyBannerProvider;
